import { SITE_URL } from '@/constants/site';
import { mainSiteUrl } from '@/mocks/categories';

export default function ArticlePage() {
  const siteUrl = SITE_URL;

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/80 backdrop-blur-md">
        <div className="w-full px-4 md:px-8">
          <div className="flex items-center justify-between h-16">
            <a href="/" className="flex items-center gap-2 no-underline">
              <span className="text-xl md:text-2xl font-heading font-bold text-foreground-950 tracking-tight">
                Kakobuy <span className="text-primary-500">Finds</span>
              </span>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Open Spreadsheet
            </a>
          </div>
        </div>
      </nav>

      <main className="pt-24 pb-16">
        <article className="max-w-[800px] mx-auto px-4 md:px-8">
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: [
                  { '@type': 'ListItem', position: 1, name: 'Strona główna', item: siteUrl },
                  { '@type': 'ListItem', position: 2, name: 'Kakobuy Sheet – Kompletny Przewodnik po Bazie Produktów i Finds', item: siteUrl + '/artykul/kakobuy-sheet-kompletny-przewodnik' },
                ],
              }),
            }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'Article',
                headline: 'Kakobuy Sheet – Kompletny Przewodnik po Bazie Produktów i Finds',
                description: 'W tym obszernym przewodniku dowiesz się wszystkiego o Kakobuy Spreadsheet — czym jest, jak działa, jakie kategorie zawiera i dlaczego tysiące użytkowników wybiera właśnie to narzędzie.',
                datePublished: '2026-07-08',
                dateModified: '2026-07-08',
                author: { '@type': 'Organization', name: 'Kakobuy Finds' },
                publisher: { '@type': 'Organization', name: 'Kakobuy Finds', logo: { '@type': 'ImageObject', url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png' } },
                image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20digital%20spreadsheet%20with%20colorful%20category%20tabs%20displayed%20on%20ultrawide%20monitor%20screen%2C%20modern%20minimalist%20home%20office%20desk%20setup%20with%20succulent%20plants%20and%20notebook%2C%20bright%20natural%20daylight%20from%20large%20window%2C%20productivity%20and%20organization%20concept%2C%20professional%20workspace%20photography&width=1200&height=600&seq=article-v2-01&orientation=landscape',
                mainEntityOfPage: { '@type': 'WebPage', '@id': siteUrl + '/artykul/kakobuy-sheet-kompletny-przewodnik' },
              }),
            }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: [
                  {
                    '@type': 'Question',
                    name: 'Czy Kakobuy Spreadsheet jest darmowy?',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: 'Tak, Kakobuy Spreadsheet jest całkowicie darmowy. Nie pobieramy żadnych opłat za dostęp do bazy produktów.',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: 'Jak często aktualizowana jest baza produktów?',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: 'Baza produktów jest aktualizowana regularnie — codziennie dodawane są nowe znaleziska, a nieaktualne linki są usuwane.',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: 'Czy mogę sugerować nowe kategorie lub produkty?',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: 'Oczywiście! Jesteśmy otwarci na sugestie naszych użytkowników. Jeśli masz pomysł na nową kategorię lub chcesz, abyśmy dodali konkretny produkt, skontaktuj się z nami.',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: 'Czy Kakobuy Spreadsheet działa na urządzeniach mobilnych?',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: 'Tak, Kakobuy Spreadsheet jest w pełni responsywny i działa płynnie na wszystkich urządzeniach — smartfonach, tabletach i komputerach.',
                    },
                  },
                ],
              }),
            }}
          />
          <nav className="mb-8" aria-label="Breadcrumb">
            <ol className="flex items-center gap-2 text-sm text-foreground-500">
              <li><a href="/" className="hover:text-foreground-800 transition-colors">Strona główna</a></li>
              <li><i className="ri-arrow-right-s-line text-xs"></i></li>
              <li className="text-foreground-800 font-medium">Kakobuy Sheet – Kompletny Przewodnik</li>
            </ol>
          </nav>

          <header className="mb-12">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-5">
              Poradnik Kakobuy
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-6">
              Kakobuy Sheet – Kompletny Przewodnik po Bazie Produktów i Finds
            </h1>
            <p className="text-base md:text-lg text-foreground-500 leading-relaxed mb-6">
              W tym obszernym przewodniku dowiesz się wszystkiego o <strong>Kakobuy Spreadsheet</strong> — czym jest, jak działa, jakie kategorie zawiera i dlaczego tysiące użytkowników wybiera właśnie to narzędzie do organizacji swoich zakupów online.
            </p>
            <div className="flex items-center gap-3 text-sm text-foreground-400">
              <span>Aktualizacja: Lipiec 2026</span>
              <span>·</span>
              <span>Czas czytania: 12 minut</span>
            </div>
          </header>

          <div className="prose-custom space-y-8">
            <section>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-10 mb-5">
                Czym jest Kakobuy Spreadsheet?
              </h2>
              <p className="text-base text-foreground-700 leading-relaxed mb-4">
                <strong>Kakobuy Spreadsheet</strong> to zaawansowana, starannie zorganizowana baza danych produktów, stworzona z myślą o wszystkich osobach, które chcą robić zakupy online szybciej, mądrzej i bardziej efektywnie. Wyobraź sobie ogromny, cyfrowy katalog, w którym znajdziesz setki — a nawet tysiące — sprawdzonych produktów z różnych kategorii, uporządkowanych w sposób przejrzysty i intuicyjny.
              </p>
              <p className="text-base text-foreground-700 leading-relaxed mb-4">
                Arkusz <strong>Kakobuy</strong> nie jest zwykłą listą zakupową. To kompleksowe narzędzie, które łączy w sobie funkcje wyszukiwarki produktów, porównywarki cen i organizeru kategorii. Każdy wpis w arkuszu zawiera bezpośredni link do produktu, co oznacza, że jednym kliknięciem możesz przejść do szczegółów oferty i dokonać zakupu.
              </p>
              <p className="text-base text-foreground-700 leading-relaxed">
                Największą zaletą <strong>Kakobuy Spreadsheet</strong> jest to, że wszystkie produkty są weryfikowane i regularnie aktualizowane. Nie musisz martwić się o nieaktualne linki czy niedostępne produkty — baza jest na bieżąco odświeżana, aby zapewnić Ci dostęp tylko do najlepszych okazji.
              </p>
            </section>

            <div className="my-10 rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20organized%20digital%20spreadsheet%20with%20colorful%20category%20tabs%20displayed%20on%20ultrawide%20monitor%20screen%2C%20modern%20minimalist%20home%20office%20desk%20setup%20with%20succulent%20plants%20and%20notebook%2C%20bright%20natural%20daylight%20from%20large%20window%2C%20productivity%20and%20organization%20concept%2C%20professional%20workspace%20photography&width=1200&height=600&seq=article-v2-01&orientation=landscape"
                alt="Kakobuy Spreadsheet - kompletny przewodnik"
                className="w-full h-auto object-cover rounded-xl"
              />
            </div>

            <section>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-10 mb-5">
                Jak działa Kakobuy Spreadsheet?
              </h2>
              <p className="text-base text-foreground-700 leading-relaxed mb-4">
                Mechanizm działania <strong>Kakobuy Spreadsheet</strong> jest prosty i intuicyjny. Arkusz został podzielony na logiczne kategorie, które odpowiadają różnym typom produktów. Każda kategoria zawiera listę starannie wyselekcjonowanych przedmiotów wraz z najważniejszymi informacjami — nazwą, opisem, orientacyjną ceną oraz bezpośrednim linkiem do strony produktu.
              </p>
              <p className="text-base text-foreground-700 leading-relaxed mb-4">
                Użytkownik może swobodnie przeglądać poszczególne kategorie, porównywać produkty i wybierać te, które najbardziej go interesują. Dzięki przejrzystemu układowi, nawet osoby początkujące szybko odnajdą się w strukturze arkusza i zaczną efektywnie z niego korzystać.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground-900 mt-8 mb-3">
                Główne funkcje arkusza:
              </h3>
              <ul className="space-y-3 list-none pl-0">
                <li className="flex items-start gap-3 text-base text-foreground-700">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg mt-0.5 flex-shrink-0"></i>
                  <span><strong>Organizacja kategorii</strong> — produkty są posegregowane według typu, co ułatwia nawigację i wyszukiwanie</span>
                </li>
                <li className="flex items-start gap-3 text-base text-foreground-700">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg mt-0.5 flex-shrink-0"></i>
                  <span><strong>Bezpośrednie linki</strong> — każdy produkt posiada aktywny link prowadzący do strony zakupu</span>
                </li>
                <li className="flex items-start gap-3 text-base text-foreground-700">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg mt-0.5 flex-shrink-0"></i>
                  <span><strong>Regularne aktualizacje</strong> — baza jest stale odświeżana, aby zapewnić aktualność wszystkich wpisów</span>
                </li>
                <li className="flex items-start gap-3 text-base text-foreground-700">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg mt-0.5 flex-shrink-0"></i>
                  <span><strong>Darmowy dostęp</strong> — z arkusza można korzystać całkowicie bezpłatnie, bez żadnych ukrytych opłat</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-10 mb-5">
                Dostępne kategorie produktów
              </h2>
              <p className="text-base text-foreground-700 leading-relaxed mb-4">
                <strong>Kakobuy Spreadsheet</strong> obejmuje szeroki wachlarz kategorii produktowych, dzięki czemu każdy znajdzie coś dla siebie. Poniżej przedstawiamy pełną listę dostępnych kategorii:
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-6">
                {[
                  { name: 'Buty', desc: 'Sneakersy, buty sportowe, eleganckie i casualowe — bogata kolekcja obuwia na każdą okazję.' },
                  { name: 'Bluzy i Swetry', desc: 'Ciepłe bluzy, swetry i hoodie od popularnych marek w atrakcyjnych cenach.' },
                  { name: 'T-Shirty', desc: 'Koszulki basic i z nadrukami — podstawa każdej garderoby w przystępnych cenach.' },
                  { name: 'Kurtki', desc: 'Kurtki zimowe, przejściowe, bomberki i jeansowe — pełen przekrój odzieży wierzchniej.' },
                  { name: 'Spodnie i Szorty', desc: 'Jeansy, spodnie materiałowe, dresowe i szorty na lato — wygoda i styl.' },
                  { name: 'Nakrycia głowy', desc: 'Czapki, beanie, kapelusze i bucket haty — dopełnij swoją stylizację.' },
                  { name: 'Zestawy', desc: 'Gotowe zestawy ubrań — idealne rozwiązanie dla osób ceniących wygodę.' },
                  { name: 'Bielizna', desc: 'Bielizna codzienna i sportowa — komfort na co dzień.' },
                  { name: 'Koszulki sportowe', desc: 'Koszulki piłkarskie i sportowe — dla fanów aktywnego stylu życia.' },
                  { name: 'Akcesoria', desc: 'Zegarki, okulary, biżuteria i inne dodatki — detale, które robią różnicę.' },
                  { name: 'Torby', desc: 'Plecaki, torby na ramię, listonoszki — funkcjonalność i design.' },
                  { name: 'Paski', desc: 'Skórzane i materiałowe paski — klasyka w nowoczesnym wydaniu.' },
                  { name: 'Perfumy', desc: 'Zapachy znanych marek — luksus w przystępnej cenie.' },
                  { name: 'Inne', desc: 'Pozostałe produkty, które nie mieszczą się w standardowych kategoriach.' },
                ].map((item) => (
                  <div key={item.name} className="p-4 rounded-lg bg-background-100 border border-background-200/70">
                    <h4 className="font-semibold text-foreground-900 font-heading text-base mb-1">{item.name}</h4>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-10 mb-5">
                Dlaczego warto korzystać z Kakobuy Spreadsheet?
              </h2>

              <p className="text-base text-foreground-700 leading-relaxed mb-4">
                Korzystanie z <strong>Kakobuy Spreadsheet</strong> niesie ze sobą szereg korzyści, które docenią zarówno początkujący, jak i zaawansowani użytkownicy platform zakupowych.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-6">
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                    <i className="ri-time-line text-lg"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 font-heading mb-2">Oszczędność czasu</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    Nie trać godzin na przeszukiwanie dziesiątek stron. Wszystkie najlepsze znaleziska są zebrane w jednym miejscu, gotowe do przeglądania.
                  </p>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                    <i className="ri-layout-grid-line text-lg"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 font-heading mb-2">Lepsza organizacja</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    Produkty są logicznie posegregowane według kategorii, co ułatwia nawigację i porównywanie różnych opcji.
                  </p>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                    <i className="ri-refresh-line text-lg"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 font-heading mb-2">Aktualne znaleziska</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    Baza jest regularnie aktualizowana — wszystkie linki są sprawdzane, a produkty dodawane na bieżąco.
                  </p>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                    <i className="ri-scales-line text-lg"></i>
                  </div>
                  <h3 className="font-semibold text-foreground-900 font-heading mb-2">Łatwiejsze porównywanie</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    Porównuj produkty obok siebie i podejmuj lepsze decyzje zakupowe na podstawie przejrzystych informacji.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-10 mb-5">
                Jak zacząć korzystać z Kakobuy Spreadsheet?
              </h2>
              <p className="text-base text-foreground-700 leading-relaxed mb-4">
                Rozpoczęcie przygody z <strong>Kakobuy Spreadsheet</strong> jest niezwykle proste i nie wymaga żadnej rejestracji ani skomplikowanej konfiguracji. Wystarczy wejść na stronę główną i od razu masz dostęp do wszystkich kategorii produktów.
              </p>
              <ol className="space-y-4 list-decimal list-inside pl-0">
                <li className="text-base text-foreground-700 leading-relaxed">
                  <strong>Wejdź na stronę</strong> — otwórz <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline">Kakobuy Spreadsheet</a> w przeglądarce
                </li>
                <li className="text-base text-foreground-700 leading-relaxed">
                  <strong>Wybierz kategorię</strong> — przejrzyj listę dostępnych kategorii i wybierz tę, która Cię interesuje
                </li>
                <li className="text-base text-foreground-700 leading-relaxed">
                  <strong>Przeglądaj produkty</strong> — zapoznaj się z listą produktów w wybranej kategorii
                </li>
                <li className="text-base text-foreground-700 leading-relaxed">
                  <strong>Kliknij link</strong> — po znalezieniu interesującego produktu kliknij w link, aby przejść do strony zakupu
                </li>
                <li className="text-base text-foreground-700 leading-relaxed">
                  <strong>Dokonaj zakupu</strong> — sfinalizuj transakcję na stronie sprzedawcy i ciesz się nowym produktem
                </li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-10 mb-5">
                Bezpieczeństwo korzystania z Kakobuy Spreadsheet
              </h2>
              <p className="text-base text-foreground-700 leading-relaxed mb-4">
                Bezpieczeństwo użytkowników jest dla nas priorytetem. Poniżej przedstawiamy najważniejsze zasady bezpiecznego korzystania z <strong>Kakobuy Spreadsheet</strong>:
              </p>
              <ul className="space-y-3 list-none pl-0">
                <li className="flex items-start gap-3 text-base text-foreground-700">
                  <i className="ri-shield-check-line text-primary-500 text-lg mt-0.5 flex-shrink-0"></i>
                  <span>Strona ma charakter wyłącznie informacyjny — nie przetwarzamy płatności ani nie sprzedajemy produktów bezpośrednio</span>
                </li>
                <li className="flex items-start gap-3 text-base text-foreground-700">
                  <i className="ri-shield-check-line text-primary-500 text-lg mt-0.5 flex-shrink-0"></i>
                  <span>Wszystkie transakcje odbywają się na zewnętrznych platformach — zawsze weryfikuj sprzedawcę przed dokonaniem zakupu</span>
                </li>
                <li className="flex items-start gap-3 text-base text-foreground-700">
                  <i className="ri-shield-check-line text-primary-500 text-lg mt-0.5 flex-shrink-0"></i>
                  <span>Nie zbieramy danych osobowych poza adresem email do newslettera</span>
                </li>
                <li className="flex items-start gap-3 text-base text-foreground-700">
                  <i className="ri-shield-check-line text-primary-500 text-lg mt-0.5 flex-shrink-0"></i>
                  <span>Zalecamy samodzielne sprawdzenie każdego produktu przed zakupem</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-10 mb-5">
                Najczęściej zadawane pytania (FAQ)
              </h2>

              <div className="space-y-5">
                <div>
                  <h3 className="font-semibold text-foreground-900 font-heading text-lg mb-2">
                    Czy Kakobuy Spreadsheet jest darmowy?
                  </h3>
                  <p className="text-base text-foreground-600 leading-relaxed">
                    Tak, <strong>Kakobuy Spreadsheet</strong> jest całkowicie darmowy. Nie pobieramy żadnych opłat za dostęp do bazy produktów — możesz swobodnie przeglądać wszystkie kategorie i korzystać ze wszystkich linków bez żadnych ograniczeń.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-foreground-900 font-heading text-lg mb-2">
                    Jak często aktualizowana jest baza produktów?
                  </h3>
                  <p className="text-base text-foreground-600 leading-relaxed">
                    Baza produktów jest aktualizowana regularnie — codziennie dodawane są nowe znaleziska, a nieaktualne linki są usuwane. Dzięki temu zawsze masz dostęp do najświeższych i najbardziej aktualnych informacji.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-foreground-900 font-heading text-lg mb-2">
                    Czy mogę sugerować nowe kategorie lub produkty?
                  </h3>
                  <p className="text-base text-foreground-600 leading-relaxed">
                    Oczywiście! Jesteśmy otwarci na sugestie naszych użytkowników. Jeśli masz pomysł na nową kategorię lub chcesz, abyśmy dodali konkretny produkt, skontaktuj się z nami — chętnie rozważymy każdą propozycję.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-foreground-900 font-heading text-lg mb-2">
                    Czy Kakobuy Spreadsheet działa na urządzeniach mobilnych?
                  </h3>
                  <p className="text-base text-foreground-600 leading-relaxed">
                    Tak, <strong>Kakobuy Spreadsheet</strong> jest w pełni responsywny i działa płynnie na wszystkich urządzeniach — smartfonach, tabletach i komputerach. Możesz przeglądać bazę produktów gdziekolwiek jesteś.
                  </p>
                </div>
              </div>
            </section>

            <section className="mt-12 p-8 rounded-xl bg-background-100 border border-background-200/70 text-center">
              <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-3">
                Gotowy, aby zacząć?
              </h2>
              <p className="text-base text-foreground-500 mb-6 max-w-md mx-auto">
                Nie czekaj dłużej. Wejdź do <strong>Kakobuy Spreadsheet</strong> i odkryj setki sprawdzonych produktów już teraz.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
                >
                  kakobuy sheet
                  <i className="ri-arrow-right-up-line"></i>
                </a>
                <a
                  href="/"
                  className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm font-semibold hover:border-foreground-700 transition-all whitespace-nowrap cursor-pointer"
                >
                  Powrót do strony głównej
                  <i className="ri-home-line"></i>
                </a>
              </div>
            </section>

            <section className="mt-6 p-6 rounded-xl bg-background-100 border border-background-200/70 text-center">
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3">
                Przeczytaj także inne poradniki
              </h3>
              <div className="flex flex-col sm:flex-row gap-2 justify-center">
                <a href="/artykul/cssbuy-spreadsheet-vs-kakobuy" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-accent-100 text-accent-800 text-sm font-medium hover:bg-accent-200 transition-all whitespace-nowrap cursor-pointer">
                  CSSBuy vs Kakobuy – Porównanie
                  <i className="ri-arrow-right-line"></i>
                </a>
                <a href="/artykul/superbuy-spreadsheet-przewodnik" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-secondary-100 text-secondary-800 text-sm font-medium hover:bg-secondary-200 transition-all whitespace-nowrap cursor-pointer">
                  Superbuy Spreadsheet – Przewodnik
                  <i className="ri-arrow-right-line"></i>
                </a>
                <a href="/artykul/oopbuy-spreadsheet-przewodnik" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-accent-100 text-accent-800 text-sm font-medium hover:bg-accent-200 transition-all whitespace-nowrap cursor-pointer">
                  Oopbuy Spreadsheet – Przewodnik
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </section>
          </div>
        </article>
      </main>

      <footer className="w-full bg-background-100 border-t border-background-200/70 py-10 px-4 md:px-8">
        <div className="max-w-[800px] mx-auto text-center">
          <a href="/" className="text-xl font-heading font-bold text-foreground-950 no-underline">
            Kakobuy <span className="text-primary-500">Finds</span>
          </a>
          <p className="text-xs text-foreground-400 mt-3">
            &copy; {new Date().getFullYear()} Kakobuy Finds. Wszelkie prawa zastrzeżone.
          </p>
        </div>
      </footer>
    </>
  );
}